module.exports = __webpack_public_path__ + "img/promotions.a5d386b4.svg";